export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">关于我们</h2>
          <div className="mt-8 bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-primary-100">
              <i className="ri-movie-2-line text-3xl text-primary-600"></i>
            </div>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              蘑菇影视是一个专注于高清影视资源聚合与分享的在线观影平台。我们致力于收集和整理全网优质的高清、超清、4K、蓝光画质的电影、电视剧、动漫、纪录片和综艺资源，为观众提供免费、无广告、流畅不缓冲的极致观影体验。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-4">
              平台每日更新海量内容，覆盖动作、科幻、喜剧、悬疑、古装、都市、动漫等多种类型，满足不同观众的多样化观影需求。我们坚持纯净观影理念，拒绝任何形式的广告干扰，让每一位用户都能沉浸在影视世界中享受纯粹的视觉盛宴。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-line text-accent-500"></i>
                <span>海量资源</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-line text-accent-500"></i>
                <span>每日更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-line text-accent-500"></i>
                <span>免费观影</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-line text-accent-500"></i>
                <span>纯净无广告</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}